rdefine('app/formular/collections/UIElementsCollection',
    [
        'backbone',
        'app/formular/models/UIFormModel',
        'app/formular/components/frm/Heading',
        'app/formular/components/frm/Subheading',
        'app/formular/components/frm/Textbox',
        'app/formular/components/frm/Textarea',
        'app/formular/components/frm/Selectbox',
        'app/formular/components/frm/Checkbox',
        'app/formular/components/frm/Datetime',
        'app/formular/components/frm/Photo',
        'app/formular/components/frm/Break',
        'app/formular/components/frm/Uploading'
    ],
    function(Backbone,UIFormModel,FHeading,FSub,FText,FArea,FSelect,FCheckbox, FDatetime,FPhoto,FBreak,FUploading){
    return Backbone.Ribs.Collection.extend({
        model:UIFormModel,
        initialize:function(){
            this.reset([
                {
                    name:_L("formular.frm.heading.title"),
                    component:FHeading,
                    type:'heading',
                    icon:'fal fa-heading'
                },
                {
                    name:_L("formular.frm.subheading.title"),
                    component:FSub,
                    type:'subheading',
                    icon:'fal fa-text-size'
                },
                {
                    name:_L("formular.frm.text.title"),
                    component:FText,
                    type:'text',
                    icon:'fal fa-rectangle-wide'
                },
                {
                    name:_L("formular.frm.area.title"),
                    component:FArea,
                    type:'textarea',
                    icon:'fal fa-square'
                },
                {
                    name:_L("formular.frm.select.title"),
                    component:FSelect,
                    type:'choice',
                    icon:'fal fa-ballot-check'
                },
                {
                    name:_L("formular.frm.checkbox.title"),
                    component:FCheckbox,
                    type:'checkbox',
                    icon:'fal fa-check-square'
                },
                {
                    name:_L("formular.frm.datetime.title"),
                    component:FDatetime,
                    type:'datetime',
                    icon:'fal fa-clock'
                },
                {
                    name:_L("formular.frm.pagebreak.title"),
                    component: FBreak,
                    type:'break',
                    icon:'fal fa-page-break'
                },
                {
                    name:_L("formular.frm.uploading.title"),
                    component: FUploading,
                    type:'uploading',
                    icon:'fal fa-file'
                }/*,
                {
                    name:_L("formular.frm.photo.title"),
                    component:FPhoto,
                    type:'photo'
                }*/
            ]);
        }
    });
});